<template>
  <div class="landing-page">
    <modal ref='modal' :data='selected'/>
    <div class="divider s2"/>
    <div class="container">
      <container class="dark" title="Projects">
        <div class="flex.row topics">
          <div
            v-for="(cat, i) in categories" :key="i" 
            @click="()=>setCategory(i)">
            <img class="category"
              :src="publicIcon+i+'.svg'"
              :class="{catselected: i == category}"/>
          </div>
        </div>
        <div class="columns is-mobile is-multiline padding">
          <project @open='openProject' v-for='(project, i) in projects' :key="i" :data='project' 
            :class="{hidden: category != null && project['categories'] != null && !project.categories.includes(category)}"
            class="column is-12-mobile is-6-tablet is-3-desktop"/>
        </div>
      </container>
    </div>
  </div>
</template>

<script>

import container from "@/components/structure/Section.vue"
import project from "@/components/structure/Project.vue"
import Modal from "@/components/structure/ProjectModal.vue"
import Projects from "@/assets/data/projects.js"
 
export default {
  name: 'About',
  components: {
    container,
    project,
    Modal
  },
  data() {
    return {
      projects: Projects,
      selected: {},
      category: null,
      publicIcon: process.env.BASE_URL+'svg/'
    }
  },
  methods: {
    openProject(project) {
      this.selected = null
      this.selected = project
      this.$refs['modal'].open();
    },
    setCategory(cat){
      this.category = (this.category == cat)? null: cat
    }
  },
  computed: {
    categories(){
      var categories = {}
      for(var project of this.projects){
        if(project['categories']){
          for(var cat of project.categories){
            categories[cat] = true
          }
        }
      }
      return categories
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page{
  min-height: 100vh;
  color: white;
  margin: 0px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: var(--second-dark);
}

.hidden{
  display: none;
}

.topics div{
  pointer-events: all;
  user-select: none;
  cursor: pointer;
  display: inline-flex;
}
.topics div *{
  pointer-events: none;
}

.category{
  width: 70px;
  padding: 10px;
  cursor: pointer;
  transition: transform 0.05s ease-out;
  pointer-events: all;
}

.catselected{
  transform: scale(1.5);
}

.col{
  height: 50%;
  display: flex;
}
.vertical{
  flex-direction: column;
}
.text{
  width:100%;
}

.align-bottom{
  align-items: flex-end;
  display: flex;
}

.align-top{
  align-items: flex-start;
  display: flex;
}

.name{
  font-family: 'caladea';
  font-style: italic;
  font-weight: bold;
}

.profession{
  color: var(--second-color);
  font-family: 'franklin gothic medium';
}

.padding{
  padding: 2em;
}

.quote{
  color: var(--second-color);
  opacity: 0.8;
  font-family: 'franklin gothic medium';
}


@media screen and (min-width:601px){
  .name{
    font-size: 5em;
  }
  .profession{
    font-size: 3em;
  }
  .quote{
    font-size: 1.5em;
  }
}

@media screen and (max-width:600px){
  .name{
    font-size: 4em;
  }
  .profession{
    font-size: 2.4em;
  }
  .quote{
    font-size: 1.5em;
  }
}



</style>
